export const sizeToDisplayMapper = {
    'Small': 'SM',
    'Medium': 'M',
    'Large': 'L',
    "Extra Large": 'XL'
}